<template>
	<b-form-select v-model="selected" :options="options" @change="onInput"></b-form-select>
</template>
<script>
import { mapState } from "vuex";

export default {
	name: "AmountTypeSelect",
	data() {
		return {
			selected: null		
		}
	},
	props: {
		value: {
			type: String,
			required: true
		}
	},
	created() {
		this.selected = this.value
	},
	methods: {
		onInput() {
			this.$emit('input', this.selected);
		}
	},
	computed: {
		...mapState({
			codes: state => state.billaudit.codes,
		}),
		options() {
			return Object.keys(this.codes).map(key => {
				return {
					text: this.codes[key],
					value: key,
				}
			})
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/BillAudit/AmountTypeSelect.vue